import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import OtpConfirmPopup from "./otpConfirmPopup";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";


/**
 * VoucherRedemConfirm component
 * Displays a confirmation page for voucher redemption, showing voucher details and points. Handles OTP popup and user actions.
 */
export const VoucherRedemConfirm = ({ selectedItem, userData }) => {
    const navigate = useNavigate();
    const [giftItem, setGiftItem] = useState(null);
    const [isLoading] = useState(false);
    const [otp, setOtp] = useState(false)
    const handleVoucherClick = () => {
        setOtp(true)
    };

    useEffect(() => {
        setGiftItem(selectedItem);
    }, [selectedItem]);

    useEffect(() => {
        setGiftItem((prevGiftItem) => ({
            ...prevGiftItem,
            voucher_mobile: userData?.user?.phone,
        }));
    }, [userData]);

    return (
        <div className="container mt-4">
            <div className="row">
                <div className="col-md-6 mt-10 pancard-data">
                    <div className="text-center mb-7">
                        <img
                            width="300"
                            alt="icon"
                            src={toAbsoluteUrl("/media/images/reconfirm-img.png")}
                        />
                    </div>
                </div>

                <div className="col-md-6 mt-10 pancard-data">
                    <div className="mt-15">
                        <h1 className="mb-5">Re-Confirm</h1>
                        <p>Please make sure you have checked all your details.</p>
                        <p className='fw-semibolder fs-5'>
                            Voucher Name : <span className='fw-semibolder text-danger'>{selectedItem?.gift_name}</span>
                        </p>
                        <p className='fw-semibolder fs-5'>
                            Redeem Point : <span className='fw-semibolder text-danger'>{selectedItem?.gift_point} pts</span>
                        </p>
                        <div className="btns cn-btn mt-15 d-flex">
                            <button
                                className="btn bgdark-blue text-white"
                                onClick={() => navigate(-1)}
                            >
                                No
                            </button>
                            <button
                                className="btn red-btn text-white"
                                style={{
                                    backgroundColor: isLoading ? "#999" : "red-btn text-white",
                                    color: "white",
                                    cursor: isLoading ? "not-allowed" : "pointer",
                                }}
                                onClick={handleVoucherClick}
                                disabled={isLoading}
                            >
                                {isLoading ? "Loading..." : "Yes"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {otp &&
                <OtpConfirmPopup show={otp} setShow={setOtp} mobile={userData?.user?.phone} redemItem={giftItem} />
            }
        </div>

    );
};
